import { Menu } from "antd";
import { Link, useHistory } from "react-router-dom";

import { path } from "@/utils/format";
import { categories } from "@/utils/constants";
import { getUserData } from "@/utils/auth";

import logoFullImgUrl from "@/assets/logo-full.png";

export const Sidebar = () => {
  const history = useHistory();
  const selectedMenu = () => {
    return categories
      .filter(
        (category) => category.path === history.location.pathname.toString(),
      )[0]
      ?.key.toString();
  };

  const menuItems = getUserData()?.role
    ? categories
        .filter((category) => category.role?.includes(getUserData()!.role))
        .flatMap((category) => {
          const visibleSubs = category.subCategories?.filter((sub) =>
            sub.role?.includes(getUserData()!.role),
          );

          if (visibleSubs && visibleSubs.length > 0) {
            return {
              key: String(category.key),
              icon: category.icon,
              label: category.name,
              children: visibleSubs.map((sub) => ({
                key: String(sub.key),
                label: <Link to={sub.path}>{sub.name}</Link>,
              })),
            };
          }

          return !category.subCategories
            ? {
                key: String(category.key),
                icon: category.icon,
                label: <Link to={category.path}>{category.name}</Link>,
              }
            : [];
        })
    : [];

  return (
    <div
      style={{
        width: 300,
        height: "100vh",
        position: "sticky",
        top: 0,
      }}
    >
      <div
        style={{
          padding: "12px 24px",
        }}
      >
        <img
          style={{ cursor: "pointer" }}
          width="100%"
          src={logoFullImgUrl}
          alt="logo"
          onClick={() => history.push("/")}
        />
      </div>
      <Menu
        style={{ height: "calc(100vh - 76px)" }}
        selectedKeys={[selectedMenu()]}
        mode="inline"
        items={menuItems}
      />
    </div>
  );
};
